<div
   class="client-verification-card"
   role="button"
   tabindex="0"
   (click)="openMeetingSchedulerModal()"
   aria-label="Client contact verification card">
   <div class="label-text">Valid Client Contact Information %</div>
   <div class="percent-value">{{ percent }}%</div>
   <div class="subtext">
      <a
         href="#"
         (click)="$event.preventDefault()">
         More Details
      </a>
   </div>
</div>
